import { CloseOutlined } from "@ant-design/icons";
import useEditPricingNotes from "@entities/pricingWorkload/lib/hooks/useEditPricingNotes";
import { ToastService } from "@shared/lib/services";
import { Button } from "@shared/ui/Button";
import { Flex, Form, Input, Space } from "antd";
import { useEffect, useState } from "react";

export default function PricingPocNotes({
  notes,
  briefInfluencerId,
  handleSuccess,
  showGoBackButton = false,
  handleGoBack,
}: {
  notes: string;
  briefInfluencerId: string;
  handleSuccess?: () => void;
  showGoBackButton?: boolean;
  handleGoBack?: () => void;
}) {
  const [form] = Form.useForm();
  const [isFocused, setIsFocused] = useState(false);

  const {
    editPricingNotes,
    isEditPricingNotesLoading,
    isEditPricingNotesSuccess,
    editPricingNotesError,
  } = useEditPricingNotes(handleSuccess);

  useEffect(() => {
    form.setFieldValue("notes", notes);
  }, [form, notes]);

  useEffect(() => {
    if (isEditPricingNotesSuccess) {
      ToastService.success("Notes updated successfully.");
    } else if (editPricingNotesError) {
      ToastService.error("Failed to update notes. Please try again.");
    }
  }, [isEditPricingNotesSuccess, editPricingNotesError]);

  const handleBlur = () => {
    setIsFocused(false);

    const currentNotes = (form.getFieldValue("notes") || "").trim();
    const originalNotes = (notes || "").trim();

    if (currentNotes !== originalNotes) {
      editPricingNotes({
        briefInfluencerId,
        notes: currentNotes,
      });
      return;
    }

    if (showGoBackButton) {
      handleGoBack?.();
    }
  };

  return (
    <Form form={form} style={{ width: "100%" }}>
      <Space.Compact>
        <Space size={4} direction="vertical">
          <Form.Item name="notes" style={{ margin: 0 }}>
            <Input.TextArea
              placeholder="Internal notes..."
              disabled={isEditPricingNotesLoading}
              onFocus={() => setIsFocused(true)}
              onBlur={handleBlur}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
          </Form.Item>
          {isFocused && showGoBackButton ? (
            <Flex justify="flex-end" gap={10}>
              <Button
                size="small"
                type="text"
                style={{ width: 10 }}
                onMouseDown={(event) => event.preventDefault()}
                onClick={(event) => {
                  event.stopPropagation();
                  handleGoBack?.();
                }}
              >
                <CloseOutlined
                  style={{
                    fontSize: 12,
                    color: "#ff4d4f",
                    cursor: "pointer",
                    padding: "4px",
                  }}
                />
              </Button>
            </Flex>
          ) : null}
        </Space>
      </Space.Compact>
    </Form>
  );
}
